var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyleSliderStressIconWhite3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 137.1",
    style: {
      enableBackground: "new 0 0 100 137.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:FFFFFF;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:FFFFFF;stroke:#FFFFFF;stroke-width:3;}\n\t.st3{fill:FFFFFF;stroke:#FFFFFF;stroke-width:2.6168;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:FFFFFF;stroke:#FFFFFF;stroke-width:2.3542;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.5,80.9c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9C40.2,78,41.5,79.3,41.5,80.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.9,80.9c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9C55.2,78,53.9,79.3,53.9,80.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 71.4,
    transform: "matrix(0.2172 -0.9761 0.9761 0.2172 -43.7571 96.0168)",
    className: "st1",
    width: 2.8,
    height: 7.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.4,
    y: 73.9,
    transform: "matrix(0.9761 -0.2172 0.2172 0.9761 -14.9837 14.2564)",
    className: "st1",
    width: 7.8,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,101l-1.4,0c0,0-2.4,0-6.2,0c-3.7,0-6.2,0-6.2,0l-1.4,0v-1.4c0-4,3.1-6.8,7.6-6.8s7.6,2.8,7.6,6.8V101z  M47.7,98.2c1.9,0,3.5,0,4.6,0c-0.7-1.9-2.8-2.7-4.6-2.7c-1.8,0-3.9,0.7-4.6,2.7C44.2,98.2,45.7,98.2,47.7,98.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1612_3_",
    transform: "translate(-122.169 -588.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1609_3_",
    transform: "translate(-575 336.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2104_3_",
    className: "st3",
    d: "M748.7,270l1.2-9.2l-5.8,3.9l1.9-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2105_3_",
    className: "st3",
    d: "M733.5,271.8l-4.7-8l-2.2,6.6l-4.4-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2106_3_",
    className: "st3",
    d: "M764,272.3l6.1-7h-7l7-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1610_3_",
    transform: "translate(-206.281 312.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1579_3_",
    transform: "translate(332.862 307.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1572_3_",
    transform: "translate(2.685 35.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1568_3_",
    transform: "translate(11.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2247_3_",
    className: "st1",
    d: "M28.7,42.2c-11,0-20.4-9.2-23.1-22.6C2.4,19.2,0,15.9,0,11.7s2.4-7.6,5.6-7.9 c0.3-1.3,0.6-2.5,1-3.8l2.6,0.9C8.7,2.4,8.3,3.9,8,5.4L7.8,6.8L6.4,6.5c-0.1,0-0.2,0-0.3-0.1c-1.8,0-3.4,2.4-3.4,5.2 s1.5,5.2,3.4,5.2c0.1,0,0.1,0,0.2,0l0.2,0l1.3-0.2L8,17.9c2.2,12.5,10.9,21.6,20.7,21.6s18.5-9.1,20.7-21.6l0.2-1.3l1.5,0.3 c0.1,0,0.1,0,0.2,0c1.8,0,3.4-2.4,3.4-5.2s-1.5-5.2-3.4-5.2c-0.1,0-0.1,0-0.2,0l-1.4,0.3l-0.4-1.6c-0.2-1.1-0.5-2.9-0.8-3.8 l2.6-0.7c0.2,0.8,0.5,2,0.6,3.1c3.1,0.4,5.5,3.7,5.5,7.9s-2.4,7.6-5.6,7.9C49.1,33,39.7,42.2,28.7,42.2L28.7,42.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1569_3_",
    transform: "translate(0 39.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2248_3_",
    className: "st1",
    d: "M2.7,30.9H0c0-8.3,7.9-11.9,15.6-15.3C23.8,12,31.5,8.5,31.5,0h2.7 c0,10.3-9.3,14.5-17.5,18.1C9.5,21.3,2.7,24.4,2.7,30.9L2.7,30.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1570_3_",
    transform: "translate(46.919 39.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2249_3_",
    className: "st1",
    d: "M34.2,30.9h-2.7c0-6.5-6.8-9.6-14-12.8C9.3,14.5,0,10.3,0,0h2.7 c0,8.5,7.7,12,15.9,15.6C26.3,19.1,34.2,22.6,34.2,30.9L34.2,30.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2257_3_",
    className: "st2",
    d: "M25.3,51.2h28.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1577_3_",
    transform: "translate(5.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2255_3_",
    className: "st1",
    d: "M0.4,39.8c-1.5-7.2,0.9-14.6,6.1-19.6c4.6-4.6,10.6-6.5,18.1-6 c0.3-1.3,0.8-2.6,1.5-3.7c2.3-3.7,5.9-6.4,10-7.6c2.7-0.6,5.6-0.5,8.3,0.5c2.2,0.6,3.9,1.1,6.2,0.1c1.1-0.5,2-1.1,2.9-1.9 c1-0.9,2.2-1.9,3.9-1.4c2.4,0.7,3.7,3.9,3.9,9.8c0.1,2.3-0.1,4.5-0.7,6.7c0.7,0,1.4,0,2.1,0c2,0.1,4,0.7,5.7,1.8 c4.6,2.9,5.6,8.2,5.8,10.4c0.2,3.2-0.2,6.4-1.3,9.5l-2.5-1.1c0.9-2.6,1.3-5.4,1.1-8.1c-0.2-1.7-1-6-4.6-8.3 c-1.3-0.8-2.8-1.3-4.4-1.4c-1.2,0-2.5,0-3.7,0.2l-2.3,0.3l0.8-2.1c0.9-2.5,1.3-5.1,1.2-7.7c-0.2-6.7-1.9-7.3-1.9-7.3 c-0.2,0-0.6,0.2-1.3,0.8c-1.1,1-2.3,1.8-3.6,2.3c-3.2,1.4-5.7,0.7-8,0c-2.2-0.8-4.6-1-6.9-0.4c-3.5,1-6.4,3.2-8.3,6.3 c-0.7,1.3-1.2,2.6-1.5,4.1l-0.2,1.3L25.5,17c-7.3-0.8-12.9,0.9-17.1,5.1C3.8,26.5,1.8,33,3.1,39.3L0.4,39.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1578_3_",
    transform: "translate(19.172 22.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2256_3_",
    className: "st1",
    d: "M8.4,15.8c-0.4,0-0.9,0-1.4-0.1c-2.6-0.2-5.1-1.3-7-3l1.8-2.1 C3.3,12,5.2,12.8,7.3,13c1.9,0.2,5.3,0,7.3-2.5c1-1.4,1.5-3.1,1.4-4.9l-0.1-1.1l1-0.3c0.5-0.1,0.9-0.2,1.4-0.2 c1.3,0,2.5,0.6,3.3,1.5c1.2,1.2,2.9,1.8,4.5,1.5c1.5-0.1,2.6-1.6,3.7-3.1c1.7-2.3,4-5.5,8.7-2.9l1,0.6l-0.4,1.1 c-0.8,2.5-0.1,5.2,1.7,7.2c1.3,1.4,3.8,2.8,7.9,1.6l0.8,2.6c-5.7,1.8-9.1-0.7-10.7-2.3c-2.2-2.4-3.1-5.6-2.6-8.8 c-1.8-0.6-2.6,0.4-4.2,2.6c-1.3,1.8-2.9,4-5.7,4.2c-2.4,0.3-4.8-0.4-6.5-2.1c-0.3-0.4-0.8-0.6-1.2-0.8c-0.1,2-0.8,3.9-2,5.4 C14.7,14.7,11.6,16,8.4,15.8L8.4,15.8z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleSliderStressIconWhite3);
export default __webpack_public_path__ + "static/media/lifestyle_slider_stress_icon_white_3.f455fa11.svg";
export { ForwardRef as ReactComponent };